import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditTypeModel } from 'app/audit/models/audit-type.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Result } from 'app/core/models/result';
import { QuestionListModel } from 'app/question/models/question-list.model';
import { QuestionService } from 'app/question/services/question.service';
import { QuestionBankQuestionListModel } from 'app/question/models/question-bank-question-list.model';
import { QuestionBankDetailsModel } from 'app/question/models/question-bank-details.model';

@Component({
  selector: 'app-question-detail-add-question-to-question-bank',
  templateUrl: './question-detail-add-question-to-question-bank.component.html',
  styleUrls: ['./question-detail-add-question-to-question-bank.component.css']
})

export class QuestionDetailAddQuestionToQuestionBankComponent implements OnInit {

    errors: string[];
    auditTypes: AuditTypeModel[];
    questions: QuestionListModel[];
    addQuestionBankQuestionForm: FormGroup;
    submitAttempt: boolean = false;
    @Input() questionId: string;
    @Input() questionBankId: string;
    @Input() isEditMode: boolean = false;
    @Output() questionBankQuestionAdded: EventEmitter<string> = new EventEmitter<string>();
    @ViewChild("addQuestion", { static: false }) modalContent: TemplateRef<any>;
    questionBankQuestions: QuestionBankQuestionListModel[];
    questionBankDetailsModel: QuestionBankDetailsModel;

    constructor(
        private questionService: QuestionService,
        private auditService: AuditService,
        private fb: FormBuilder,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.getAuditTypes();
        this.getQuestions();

        this.questionService.getQuestionBankQuestions(this.questionBankId).subscribe(
            questionBankQuestions => {
                this.questionBankQuestions = questionBankQuestions;
                this.initializeForm();
            },
            error => this.errors = error.errorList
        );
        this.questionService.getQuestionBank(this.questionBankId).subscribe(questionBankDetailsModel => {
            this.questionBankDetailsModel = questionBankDetailsModel;
        });
    }

    ngAfterViewInit(): void {
        this.modalService.open(this.modalContent);
    }

    initializeForm(): void {
        this.addQuestionBankQuestionForm = this.fb.group({
            questionBankId: [this.questionBankId],
            questionId: [this.questionId],
            auditTypeId: [''],
            zOrder: [this.questionBankQuestions.length + 1, Validators.required],
            isMandatory: [true, Validators.required]
        });
    }

    getAuditTypes(): void {
        this.auditService.getAuditTypes().subscribe(result => {
            this.auditTypes = result;
        });
    }

    getQuestions(): void {
        this.questionService.getAll().subscribe(result => {
            this.questions = result;
        });
    }

    addQuestionToQuestionBank(): void {
        this.submitAttempt = true;

        if (this.addQuestionBankQuestionForm.valid) {
            const formValue = this.addQuestionBankQuestionForm.value;
            this.questionService.addQuestionBankQuestion(formValue).subscribe(
                result => {
                    this.questionBankQuestionAdded.emit(result);
                    //this.addQuestionBankQuestionForm.reset();
                    //this.addQuestionBankQuestionForm.patchValue({ "questionBankId": this.questionBankId, "isMandatory": false });
                    this.initializeForm();
                    this.submitAttempt = false;
                    this.modalService.dismissAll('saved');
                },
                error => {
                    this.errors = (<Result>error).errorList;
                    this.submitAttempt = false;
                }
            );
        }
    }

    openAddQuestion(content) {
        this.modalService.open(content);
    }
}
